module.exports = __webpack_public_path__ + "img/fwx4.73fecdcc.png";